// extracted by mini-css-extract-plugin
module.exports = {"favorite":"dormancy-account-list_favorite_1lJLG","active":"dormancy-account-list_active_2UJ_X"};